import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { LazyLoadEvent, MessageService, MenuItem } from 'primeng/api';
import { AppDataService, PromosService } from 'app/services';
import { PartnerMarketingPromotionsComponent } from 'app/partner';
import { PromoTypeEnum, DayOfWeekEnum, PromoAvailableTypeEnum } from 'app/models';
import * as moment from 'moment';
import { Utils } from 'app/utils';
import { cl } from '@fullcalendar/core/internal-common';

enum MenuTab {
    PromoDetails = 1,
    Mechanics = 2,
    Validity = 3,
    Products = 4,
    Locations = 5,
    Preview = 6
}

@Component({
    selector: 'partner-marketing-add-edit-promotion',
    templateUrl: './partner-marketing-add-edit-promotion.component.html',
    styleUrls: ['./partner-marketing-add-edit-promotion.component.scss',
        '../../../../../styles/sidebar.scss',
        '../../../../../styles/style-layout.scss'],
    providers: [MessageService]
})
export class PartnerMarketingAddEditPromotionComponent implements OnInit {
    public isMerchant: boolean = false;
    public merchantId: number = 0;

    public promoId: number = 0;
    @Input()
    set _promoId(value: number) {
        if (value > 0) {
            this.promoId = value;
            this.getMerchantPromo();
        }
    }

    public showAddEditPromotionSideBar: boolean = false;
    @Input()
    set _showAddEditPromotionSideBar(value: boolean) {
        this.showAddEditPromotionSideBar = value;
    }

    @Input()
    set _promoTypeId(value: PromoTypeEnum) {
        this.changePromoType(value);
    }

    @Input() public partnerMarketingPromotionsComponent!: PartnerMarketingPromotionsComponent;

    @Output() changedShowAddEditPromotionSideBarEmit = new EventEmitter<boolean>();
    changedShowAddEditPromotionSideBar(increased: any) {
        this.changedShowAddEditPromotionSideBarEmit.emit(increased);
    }

    public sideBarHeaderTitle: string = 'Choose a Promotion Type';

    public promoAvailableType = PromoAvailableTypeEnum;
    public promoTypeEnum = PromoTypeEnum;
    public activePromoType!: PromoTypeEnum;

    public menuTab = MenuTab;
    public activeMenuTab: MenuTab = MenuTab.PromoDetails;

    public daysWeek: any[] = [
        { name: 'Mon', value: DayOfWeekEnum.Monday },
        { name: 'Tue', value: DayOfWeekEnum.Tuesday },
        { name: 'Wed', value: DayOfWeekEnum.Wednesday },
        { name: 'Thu', value: DayOfWeekEnum.Thursday },
        { name: 'Fri', value: DayOfWeekEnum.Friday },
        { name: 'Sat', value: DayOfWeekEnum.Saturday },
        { name: 'Sun', value: DayOfWeekEnum.Sunday }
    ];

    public promo: any = {};

    public showLimit: boolean = false;
    public showLimitPerDay: boolean = false;
    public showBetweenTimeOfday: boolean = false;

    public loading: boolean = false;

    constructor(private messageService: MessageService, public appData: AppDataService,
        public promosService: PromosService) {
        this.merchantId = parseInt(this.appData.authData.MerchantId, 10);
        this.isMerchant = this.appData.isMerchant();
    }

    ngOnInit(): void {
    }

    public changePromoType(item: PromoTypeEnum) {
        this.activePromoType = item;
        this.promo.PromoTypeId = this.activePromoType;
        if (item === PromoTypeEnum.PercentageDiscount) {
            this.sideBarHeaderTitle = 'Percentage Discount';
        }
        else if (item === PromoTypeEnum.FixedAmountDiscount) {
            this.sideBarHeaderTitle = 'Fixed Amount Discount';
        }
        else if (item === PromoTypeEnum.DeliveryFeeDiscount) {
            this.sideBarHeaderTitle = 'Delivery Fee Discount';
        }
        else if (item === PromoTypeEnum.FreeItemPromo) {
            this.sideBarHeaderTitle = 'Free Item Promo';
        }
    }

    public changeActiveMenuTab(item: MenuTab) {
        this.activeMenuTab = item;
    }

    public limitClick(isShow: boolean) {
        if (!isShow) {
            this.promo.MaxUseCount = 0;
            this.showLimit = false;
        }
        else {
            this.promo.MaxUseCount = null;
            this.showLimit = true;
        }
    }
    public limitPerDayClick(isShow: boolean) {
        if (!isShow) {
            this.promo.MaxUsePerDayCount = 0;
            this.showLimitPerDay = false;
        }
        else {
            this.promo.MaxUsePerDayCount = null;
            this.showLimitPerDay = true;
        }
    }
    public betweenTimeOfDayClick(isShow: boolean) {
        this.promo.BetweenStartTime = null;
        this.promo.BetweenEndTime = null;
        this.showBetweenTimeOfday = isShow;
    }

    public handleImageClick(id: string): void {
        document.getElementById(id)?.click();
    }

    public handleImageChange(event: Event) {
        const target = event.target as HTMLInputElement;

        let file: File | null = null;

        if (target.files) {
            file = target.files[0];
        }

        if (!file) {
            return;
        }

        // Chech max file size 2MB
        if (file.size > 2097152) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'This file is bigger than 2MB.' });
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            if (e?.target?.result) {
                // Base64 string
                this.promo.ImageUrl = e.target.result.toString();
            }
        };

        reader.readAsDataURL(file);
    }

    public getMerchantPromo() {
        this.loading = true;

        const dto = {
            PromoId: this.promoId,
            MerchantId: this.merchantId
        };

        this.promosService.getMerchantPromo(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    this.loading = false;
                    return;
                }
                this.promo = data;
                console.log(this.promo);

                if (!this.promo.MaxUseCount) {
                    this.showLimit = false;
                    this.promo.selectedLimit = false;
                }
                else {
                    this.showLimit = true;
                    this.promo.selectedLimit = true;
                }

                if (!this.promo.MaxUsePerDayCount) {
                    this.showLimitPerDay = false;
                    this.promo.selectedLimitPerDay = false;
                }
                else {
                    this.showLimitPerDay = true;
                    this.promo.selectedLimitPerDay = true;
                }

                if (this.promo.StartedAt) {
                    this.promo.StartedAt = new Date(this.promo.StartedAt);
                    this.promo.StartedAtTime = this.promo.StartedAt;
                }
                if (this.promo.ValidUntil) {
                    this.promo.ValidUntil = new Date(this.promo.ValidUntil);
                    this.promo.ValidUntilTime = this.promo.ValidUntil;
                }

                if (this.promo.BetweenStartTimeAt && this.promo.BetweenEndTimeAt) {
                    this.promo.whileStoreIsOpen = true;
                    this.showBetweenTimeOfday = true;
                    this.promo.BetweenStartTime = new Date(this.promo.BetweenStartTimeAt);
                    this.promo.BetweenEndTime = new Date(this.promo.BetweenEndTimeAt);
                }

                this.loading = false;
            });
    }

    public clickSavePromo(): void {
        this.promo.MerchantId = this.merchantId;
        this.promo.PromoAvailableType = +this.promo.PromoAvailableType;

        const startedAt = this.promo.StartedAt;
        const endedAt = this.promo.ValidUntil;
        if (this.promo.ValidUntil) {
            if (this.promo.ValidUntilTime) {
                this.promo.ValidUntil.setHours(this.promo.ValidUntilTime.getHours());
                this.promo.ValidUntil.setMinutes(this.promo.ValidUntilTime.getMinutes());
            }
            else {
                this.promo.ValidUntil.setHours(23);
                this.promo.ValidUntil.setMinutes(59);
            }
            this.promo.ValidUntil = moment(this.promo.ValidUntil).format('YYYY-MM-DDTHH:mm:ss');
        }
        if (this.promo.StartedAt) {
            if (this.promo.StartedAtTime) {
                this.promo.StartedAt.setHours(this.promo.StartedAtTime.getHours());
                this.promo.StartedAt.setMinutes(this.promo.StartedAtTime.getMinutes());
            }
            else {
                this.promo.StartedAt.setHours(0);
                this.promo.StartedAt.setMinutes(0);
            }
            this.promo.StartedAt = moment(this.promo.StartedAt).format('YYYY-MM-DDTHH:mm:ss');
        }

        if (this.promo.BetweenStartTime) {
            this.promo.BetweenStartTime = moment(this.promo.BetweenStartTime).format('YYYY-MM-DDTHH:mm:ss');
        }
        if (this.promo.BetweenEndTime) {
            this.promo.BetweenEndTime = moment(this.promo.BetweenEndTime).format('YYYY-MM-DDTHH:mm:ss');
        }

        if (!this.promo.Name || !this.promo.Code || !this.promo.Description
            || !this.promo.UseAmount || !this.promo.MinSpend || !this.promo.PromoAvailableType
            || !this.promo.StartedAt || !this.promo.StartedAtTime || !this.promo.ValidUntil || !this.promo.ValidUntilTime
            || !this.promo.SelectedDayWeeks) {
            const errMsg = `Name, Internal Reference, Promo Description, Peso Discount, Minimum Spend, Avail Promo, 
            Start date and time, End date and time, Applicable days`;
            this.messageService.add({ severity: 'error', summary: 'Warning', detail: errMsg });
            this.promo.StartedAt = startedAt;
            this.promo.ValidUntil = endedAt;
            return;
        }

        this.loading = true;
        this.promosService.addOrUpdateMerchantPromo(this.promo, this.messageService)
            .then(data => {
                this.promo.StartedAt = startedAt;
                this.promo.ValidUntil = endedAt;
                if (!data) {
                    this.loading = false;
                    return;
                }
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    this.loading = false;
                    return;
                }
                this.loading = false;
                this.partnerMarketingPromotionsComponent.getMerchantPromos(0, {});
                this.cancel();
            });

    }

    checkIsActiveMenu(menuTab: MenuTab) {
        const allowedMenuTabs: Record<number, MenuTab[]> = {
            [MenuTab.PromoDetails]: [
                MenuTab.PromoDetails
            ],
            [MenuTab.Mechanics]: [
                MenuTab.PromoDetails,
                MenuTab.Mechanics
            ],
            [MenuTab.Validity]: [
                MenuTab.PromoDetails,
                MenuTab.Mechanics,
                MenuTab.Validity
            ],
            [MenuTab.Products]: [
                MenuTab.PromoDetails,
                MenuTab.Mechanics,
                MenuTab.Validity,
                MenuTab.Products
            ],
            [MenuTab.Locations]: [
                MenuTab.PromoDetails,
                MenuTab.Mechanics,
                MenuTab.Validity,
                MenuTab.Products,
                MenuTab.Locations
            ],
            [MenuTab.Preview]: [
                MenuTab.PromoDetails,
                MenuTab.Mechanics,
                MenuTab.Validity,
                MenuTab.Products,
                MenuTab.Locations,
                MenuTab.Preview
            ]
        };

        if (allowedMenuTabs[this.activeMenuTab]?.includes(menuTab)) {
            return true;
        }

        return false;
    }

    cancel() {
        this.changedShowAddEditPromotionSideBar(false);
    }
}
